export default {
  'clocks': [
    'clock0800_1000',
    'clock1000_1200',
    'clock1200_1400',
    'clock1400_1600'
  ]
}
